module.exports = __webpack_public_path__ + "static/projekt_indywidualny_b5-9e535d3db0c455d701439f19adfef5eb.jpg";